import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TR_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#TR_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TR_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#TR_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.025 16.114c-2.141-.528-3.818-2.32-3.799-4.948.019-2.459 1.508-4.538 3.862-5.1 2.354-.563 4.426.631 4.426.631-.65-1.536-2.91-2.614-4.764-2.611-3.449.005-7.126 2.803-7.158 7.08-.032 4.435 3.938 6.961 7.43 6.955 2.799-.004 4.127-1.92 4.402-2.734 0 0-2.257 1.254-4.399.727zm4.879-5.787l-2.134.784 2.407.849-.04 2.537 1.586-1.903 2.62.19-2.077-1.785 1.364-1.904-2.22.747-1.586-1.763.08 2.248z",
      fill: "#F7FCFF"
    }
  )))
), a = t;
export {
  a as default
};
